import { InjectionToken } from '@angular/core';

import { PlatformService } from './platform.service';

export const WINDOW = new InjectionToken<Window>('WindowToken');

export function windowFactory(platform: PlatformService): Window | Object {
  return platform.isBrowser() ? window : { };
}
